<header class="admin-header" *ngIf="isMobile" style="display: flex; justify-content: space-between; padding: 15px; width: 100%; position: relative; z-index: 1001; background: #fff; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">
  <div class="left-side-menu hamburger-menu" (click)="toggleSidebar()">
    <svg viewBox="0 0 100 80" width="30" height="30" style="fill: #f58634; cursor: pointer;">
      <rect width="100" height="15" rx="8"></rect>
      <rect y="30" width="100" height="15" rx="8"></rect>
      <rect y="60" width="100" height="15" rx="8"></rect>
    </svg>
  </div>
  <div class="right-side-menu" style="display: flex; align-items: center; justify-content: flex-end; width: 100%;">
    <span class="cursor-pointer" style="margin-right: 15px;" (click)="getTripsList('notifications')">
      <img src="assets/img/bell.svg" style="width: 20px;" />
    </span>
    <span>
      <div class="dropdown" matTooltip="Profile">
        <a mat-button [matMenuTriggerFor]="mobileMenu" style="display: flex; align-items: center; color: #060606; font-weight: 500;">
          <img class="header-profile" style="width: 20px; height: 20px; border-radius: 50%; margin-right: 8px;" src="{{ profilePic ? profilePic : 'assets/img/profilesimg.svg' }}" />
          Hi, <span style="text-transform: capitalize; color: #f58634; margin-left: 5px;">{{ truckOwner?.username }}</span>
        </a>
        <mat-menu #mobileMenu="matMenu">
          <button mat-menu-item (click)="GoToProfile()">Profile</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="GoToOrders()">Orders</button>
          <div class="seperator"></div>
          <button mat-menu-item (click)="logout()">Logout</button>
        </mat-menu>
      </div>
    </span>
  </div>
</header>
<mat-sidenav-container class="example-container" [class.mobile-open]="isMobile && opened" [class.mobile-closed]="isMobile && !opened">
  <mat-sidenav
    [mode]="mode"
    class="sidebar"
    [(opened)]="opened"
    (openedChange)="onOpenedChange($event)"
    (keydown)="preventEscClose($event)"
    tabindex="0"
    [fixedInViewport]="isMobile"
  >
    <div class="sidebar-header"
      style="display: flex; justify-content: center; align-items: center; padding-right: 15px; position: relative;">
      <h6 class="logo" style="margin-bottom: 0; margin-top: 5px;">S9</h6>
      <div class="sidebar-close-btn" *ngIf="isMobile" (click)="toggleSidebar()"
        style="cursor: pointer; margin-top: 20px; position: absolute; right: 15px;">
        <svg viewBox="0 0 100 80" width="25" height="25" style="fill: #f58634;">
          <rect width="100" height="15" rx="8"></rect>
          <rect y="30" width="100" height="15" rx="8"></rect>
          <rect y="60" width="100" height="15" rx="8"></rect>
        </svg>
      </div>
    </div>
    <div class="description-logo">
      <p>Transporter</p>
    </div>
    <div class="truck-sidenav">
      <div
        [ngClass]="{ active: tripType == 'preOrders' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('preOrders')">Pre Orders</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'trucks' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('trucks')">Trucks</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'drivers' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('drivers')">Drivers</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'deliveryOrders' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('deliveryOrders')">Delivery Orders</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'mapping' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('mapping')">Mapping</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'driverOrders' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('driverOrders')">Driver Orders</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'orders' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('orders')">Trips</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'payments' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('payments')">Payments</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'track' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('track')">Track</h2>
      </div>
      <div
        [ngClass]="{ active: tripType == 'reports' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('reports')">Reports</h2>
      </div>
      <!-- <div
        [ngClass]="{ active: tripType == 'preOrderSetting' }"
        class="truck-sidenav-menu"
        *ngIf="preOrderType == 'preOrderSetting'"
      >
        <h2 (click)="getTripsList('preOrderSetting')">Pre Order Settings</h2>
      </div> -->
      <div
        [ngClass]="{ active: tripType == 'help' }"
        class="truck-sidenav-menu"
      >
        <h2 (click)="getTripsList('help')">Help</h2>
      </div>
    </div>
  </mat-sidenav>
  <mat-sidenav-content class="mainContent">

    <div class="row m-0">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
  <mat-sidenav
    position="end"
    [mode]="mode"
    class="sidebar-right"
    *ngIf="local_storage_data != 'true'"
    opened
    [fixedInViewport]="isMobile"
  >
    <mat-card>
      <div class="truck-right-header">
        <span><img src="assets/img/location.svg" /> <a>Track</a></span>
        <!-- <span> <img src="assets/img/bell.svg" />Notifications</span> -->
        <span class="cursor-pointer" (click)="getTripsList('notifications')">
          <img src="assets/img/bell.svg" /> Notifications
        </span>
        <span>
          <div class="dropdown" matTooltip="Profile">
            <a mat-button [matMenuTriggerFor]="menu"
              ><img
                class="header-profile"
                src="{{
                  profilePic ? profilePic : 'assets/img/profilesimg.svg'
                }}"
              />Hi,
              <span style="text-transform: capitalize">{{
                truckOwner?.username
              }}</span>
            </a>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="GoToProfile()">Profile</button>
              <div class="seperator"></div>
              <button mat-menu-item (click)="GoToOrders()">Orders</button>
              <div class="seperator"></div>
              <button mat-menu-item (click)="logout()">Logout</button>
            </mat-menu>
          </div>
        </span>
      </div>
      <div class="truck-right-content">
        <div class="row">
          <div class="col-sm-5">
            <mat-card class="live_trip">
              <h5>Live Trip</h5>
              <p>{{ dashboardArray.liveTrips }}</p>
            </mat-card>
          </div>
          <div class="col-sm-7">
            <mat-card class="live_trip">
              <h5>Upcoming Trip</h5>
              <p>{{ dashboardArray?.upcomingTrips }}</p>
            </mat-card>
          </div>
        </div>
      </div>
      <div class="truck-right-card">
        <mat-card>
          <div class="truck-right-heading">
            Trucks ({{
              dashboardArray.trucks?.allocatedTrucks +
                dashboardArray.trucks?.trucksAvailable +
                dashboardArray.trucks?.trucksIdle
            }})
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.trucks?.trucksAvailable }}
            </div>
            <div class="truck-right-card-p">Available</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.trucks?.allocatedTrucks }}
            </div>
            <div class="truck-right-card-p">Allocated</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.trucks?.truckInTrips }}
            </div>
            <div class="truck-right-card-p">In Trip</div>
          </div>

          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.trucks?.trucksIdle }}
            </div>
            <div class="truck-right-card-p">Idle</div>
          </div>
        </mat-card>
      </div>
      <div class="truck-right-card">
        <mat-card>
          <div class="truck-right-heading">
            Drivers ({{
              dashboardArray.drivers?.drivers +
                dashboardArray.drivers?.driversRejected +
                dashboardArray.drivers?.driversAvailable
            }})
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.drivers?.drivers }}
            </div>
            <div class="truck-right-card-p">All</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.drivers?.driversAvailable }}
            </div>
            <div class="truck-right-card-p">Available</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.drivers?.driversInTrips }}
            </div>
            <div class="truck-right-card-p">In Trip</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.drivers?.driversRejected }}
            </div>
            <div class="truck-right-card-p">Rejected</div>
          </div>
        </mat-card>
      </div>
      <div class="truck-right-card">
        <mat-card>
          <div class="truck-right-heading">Map my T & D</div>
          <div class="truck-right-card-point-last">
            <div class="truck-right-card-head">
              {{ dashboardArray.mappings?.mapped }}
            </div>
            <div class="truck-right-card-p">Assigned</div>
          </div>
          <div class="truck-right-card-point-last">
            <div class="truck-right-card-head">
              {{ dashboardArray.mappings?.trucksAvailable }}
            </div>
            <div class="truck-right-card-p">Available Trucks</div>
          </div>
          <div class="truck-right-card-point-last">
            <div class="truck-right-card-head">
              {{ dashboardArray.mappings?.driversAvailable }}
            </div>
            <div class="truck-right-card-p">Available Drivers</div>
          </div>
        </mat-card>
      </div>
    </mat-card>
  </mat-sidenav>
  <!-- ******************** -->
  <!-- <mat-sidenav
    position="end"
    mode="side"
    class="sidebar-right"
    *ngIf="preOrderType === 'preOrderSetting'"
    opened
  >
    <mat-card>
      <div class="truck-right-header">
        <span><img src="assets/img/location.svg" /> <a>Track</a></span>
        <span> <img src="assets/img/bell.svg" /></span>
        <span>
          <div class="dropdown" matTooltip="Profile">
            <a mat-button [matMenuTriggerFor]="menu"
              ><img
                class="header-profile"
                src="{{
                  profilePic ? profilePic : 'assets/img/profilesimg.svg'
                }}"
              />Hi,
              <span style="text-transform: capitalize">{{
                truckOwner?.username
              }}</span>
            </a>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="GoToProfile()">Profile</button>
              <div class="seperator"></div>
              <button mat-menu-item (click)="GoToOrders()">Orders</button>
              <div class="seperator"></div>
              <button mat-menu-item (click)="logout()">Logout</button>
            </mat-menu>
          </div>
        </span>
      </div>
      <div class="truck-right-content">
        <div class="row">
          <div class="col-sm-5">
            <mat-card class="live_trip">
              <h5>Live Trip</h5>
              <p>{{ dashboardArray.liveTrips }}</p>
            </mat-card>
          </div>
          <div class="col-sm-7">
            <mat-card class="live_trip">
              <h5>Upcoming Trip</h5>
              <p>{{ dashboardArray?.upcomingTrips }}</p>
            </mat-card>
          </div>
        </div>
      </div>
      <div class="truck-right-card">
        <mat-card>
          <div class="truck-right-heading">
            Trucks ({{
              dashboardArray.trucks?.allocatedTrucks +
                dashboardArray.trucks?.trucksAvailable +
                dashboardArray.trucks?.trucksIdle
            }})
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.trucks?.trucksAvailable }}
            </div>
            <div class="truck-right-card-p">Available</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.trucks?.allocatedTrucks }}
            </div>
            <div class="truck-right-card-p">Allocated</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.trucks?.truckInTrips }}
            </div>
            <div class="truck-right-card-p">In Trip</div>
          </div>

          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.trucks?.trucksIdle }}
            </div>
            <div class="truck-right-card-p">Idle</div>
          </div>
        </mat-card>
      </div>
      <div class="truck-right-card">
        <mat-card>
          <div class="truck-right-heading">
            Drivers ({{
              dashboardArray.drivers?.drivers +
                dashboardArray.drivers?.driversRejected +
                dashboardArray.drivers?.driversAvailable
            }})
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.drivers?.drivers }}
            </div>
            <div class="truck-right-card-p">All</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.drivers?.driversAvailable }}
            </div>
            <div class="truck-right-card-p">Available</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.drivers?.driversInTrips }}
            </div>
            <div class="truck-right-card-p">In Trip</div>
          </div>
          <div class="truck-right-card-point">
            <div class="truck-right-card-head">
              {{ dashboardArray.drivers?.driversRejected }}
            </div>
            <div class="truck-right-card-p">Rejected</div>
          </div>
        </mat-card>
      </div>
      <div class="truck-right-card">
        <mat-card>
          <div class="truck-right-heading">Map my T & D</div>
          <div class="truck-right-card-point-last">
            <div class="truck-right-card-head">
              {{ dashboardArray.mappings?.mapped }}
            </div>
            <div class="truck-right-card-p">Assigned</div>
          </div>
          <div class="truck-right-card-point-last">
            <div class="truck-right-card-head">
              {{ dashboardArray.mappings?.trucksAvailable }}
            </div>
            <div class="truck-right-card-p">Available Trucks</div>
          </div>
          <div class="truck-right-card-point-last">
            <div class="truck-right-card-head">
              {{ dashboardArray.mappings?.driversAvailable }}
            </div>
            <div class="truck-right-card-p">Available Drivers</div>
          </div>
        </mat-card>
      </div>
    </mat-card>
  </mat-sidenav> -->
</mat-sidenav-container>
